import { gql } from '@apollo/client';
import { PARTNERSHIP_FIELDS } from '@/graphql/fragments/partnerships';
import { CLIENT_FIELDS } from '@/graphql/queries/clients';

// Shared with CorporateUsers, so it stays in graphql/mutations/users.js.
export { SET_USER_CIRCLE } from '@/graphql/mutations/users';

/** Connects this carrier to an existing shipper (Add Shipper → Connect). */
export const CONNECT_SHIPPING_PARTNER = gql`
    ${PARTNERSHIP_FIELDS}
    ${CLIENT_FIELDS}
    mutation ConnectShippingPartner($partnership: partnerships_insert_input!) {
        insert_partnerships_one(object: $partnership) {
            ...PartnershipFields
            shipper {
                ...ClientFields
            }
        }
    }
`;

/** Saves the carrier's side of a partnership (the Details page's manifest sharing). */
export const UPDATE_SHIPPING_PARTNER = gql`
    ${PARTNERSHIP_FIELDS}
    ${CLIENT_FIELDS}
    mutation UpdateShippingPartner($partnership_id: uuid!, $update: partnerships_set_input!) {
        update_partnerships(where: { partnership_id: { _eq: $partnership_id } }, _set: $update) {
            returning {
                ...PartnershipFields
                shipper {
                    ...ClientFields
                }
                carrier {
                    ...ClientFields
                }
            }
        }
    }
`;

/** Ends the carrier–shipper connection. Returns only the id, for evicting it from the cache. */
export const DELETE_SHIPPING_PARTNER = gql`
    mutation DeleteShippingPartner($partnership_id: uuid!) {
        delete_partnerships_by_pk(partnership_id: $partnership_id) {
            partnership_id
        }
    }
`;
